import { Hint } from '@progress/kendo-react-labels'
import {MaskedTextBox} from '@progress/kendo-react-inputs'
import parse from 'html-react-parser'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_GetValueResponse } from '../../../api'
import { Label, Error } from "@progress/kendo-react-labels";
import { useEffect, useRef, useState } from 'react'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation,faCircleCheck, faLightbulbOn} from '@fortawesome/pro-regular-svg-icons';

export interface GetValueSSNProps {
    id: number,
    question: string,
    minLength: number,
    maxLength: number,
    inputFormat?:string,
    confirmQuestion?: string
    defaultAnswer: string,
    focus:boolean
    callback: (response: SurveyEngine_Models_BaseResponse) => void
}

export const GetValueSSN = (props: GetValueSSNProps) => {

    const [isError, setIsError] = useState(false);
    const [value, setValue] = useState<string | undefined>(props.defaultAnswer ?? undefined);
    const [confirmValue, setConfirmValue] = useState<string | undefined>(undefined);
    const [touched, setTouched] = useState(false);
    const [confirmTouched, setConfirmTouched] = useState(false);
    const [match, setMatch] = useState(false);

    const globalCTX = useGlobalCtx()

    const labelId = `${props.id}_label`
    const InputId = `${props.id}_Input`
    const confirmLabelId = `${props.id}_confirmLabel`
    const confirmInputId = `${props.id}_confirmInput`
  
    const errorId = `${props.id}_error`
    const confirmErrorId = `${props.id}_confirmError`
  
    const gvSSNRef = useRef<MaskedTextBox>(null);
    const gvSSNConfirmRef = useRef<MaskedTextBox>(null)
    useEffect(() => {
        if(props.focus)
        {
          if (props.confirmQuestion) {
            if ((value && value.length > 0 && !match && gvSSNConfirmRef)|| match) {
              gvSSNConfirmRef.current?.focus();
            }
            else {
              gvSSNRef.current?.element?.focus();
            }
          }
          else if (gvSSNRef) {
            gvSSNRef.current?.element?.focus();
          }
        }        
        if(props.defaultAnswer && props.defaultAnswer.length > 0)
        {
          let response = {
            commandType: "GetValue",
            commandIndex: props.id,
            value: props.defaultAnswer
          };
          props.callback(response);
        }
    
      }, [props, match, value])
    
    
      const HandleGetValueChange = (e: string | undefined) => {
        let response: SurveyEngine_Models_GetValueResponse = {
          commandType: "Remove",
          commandIndex: props.id,
          value: "-1"
        };
        //SSN Mask format
        if (e?.indexOf("_") !== -1) {
          e = ""
          setIsError(true);
        }
        else
        {
            setIsError(false);
        }
    
        if (!props.confirmQuestion) {
          if (e?.length === 0) {
            if (props.minLength === 0) {
              response = {
                commandType: "GetValue",
                commandIndex: props.id,
                value: "0"
              }
            }
          }
          else if (e) {
            response = {
              commandType: "GetValue",
              commandIndex: props.id,
              value: e
            }
          }
        }
        else {
          if (e !== confirmValue) {
            setMatch(false);
          }
          else {
            if (e && confirmValue) {
              setMatch(true);
              response = {
                commandType: "GetValue",
                commandIndex: props.id,
                value: e
              }
            }
          }
    
        }
        props.callback(response);
        setValue(e);
    
      }
    
      const HandleConfirmValueChange = (e: string | undefined) => {
    
        let response: SurveyEngine_Models_GetValueResponse = {
          commandType: "Remove",
          commandIndex: props.id,
          value: "-1"
        };;
    
        if (value !== e) {
          setMatch(false);
        }
        else {
          if (value?.length === 0 && props.minLength === 0) {
            response = {
              commandType: "GetValue",
              commandIndex: props.id,
              value: "0"
            }
          }
          else {
            if (e && confirmValue) {
              response = {
                commandType: "GetValue",
                commandIndex: props.id,
                value: e
              }
            }
          }
    
          setMatch(true);
        }
        props.callback(response);
        setConfirmValue(e);
      }
    return(<div className="theme-get-value mb-3 w-full">
    <Label
      className="theme-question text-xl font-semibold w-full block"
      id={labelId}
      editorId={InputId}
    >
      {parse(props.question.replace(/""/g,'"'))}
    </Label>
    <MaskedTextBox
      className="theme-answer w-full block"
      ref={gvSSNRef}
      id={InputId}
      value={value ? value : undefined}
      mask={props.inputFormat?.replaceAll("D","0")??"000-00-0000"}
      ariaDescribedBy={errorId}
      onChange={(e) => HandleGetValueChange(e.value?.toString())}
      onBlur={() => setTouched(true)}
      valid={true}
    />
    {(touched && !value) || isError ? <Error className="theme-validator-error-text font-semibold" direction='start' id={errorId}><FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />{globalCTX.LangResources.getValueMsg.SSN.error}</Error> : <Hint className="theme-validator-hint-text font-semibold" direction='start'  id={errorId}><FontAwesomeIcon icon={faLightbulbOn} className="theme-icon-spacer" />{globalCTX.LangResources.getValueMsg.SSN.hint}</Hint>}
    {props.confirmQuestion &&
      <>
        <Label
          className="theme-question text-xl font-semibold w-full block"
          id={confirmLabelId}
          editorId={confirmInputId}
        >
          {parse(props.confirmQuestion.replace(/""/g,'"'))}
        </Label>
        <MaskedTextBox
          className="theme-answer w-full block"
          ref={gvSSNConfirmRef}
          id={confirmInputId}
          mask={props.inputFormat?.replaceAll("D","0")??"000-00-0000"}
          value={confirmValue ? confirmValue : undefined}
          ariaDescribedBy={confirmErrorId}
          onChange={(e) => HandleConfirmValueChange(e?.value?.toString())}
          onFocus={() => setConfirmTouched(true)}
          valid={true}
        />
        {confirmTouched && !match ?<Error className="theme-validator-error-text font-semibold" direction='start' id={confirmErrorId}>{globalCTX.LangResources.getValueMsg.confirmValueError}</Error>: match?<Hint className="theme-validator-success-text font-semibold" direction='start' id={confirmErrorId}><FontAwesomeIcon icon={faCircleCheck} className="theme-icon-spacer" />{globalCTX.LangResources.getValueMsg.confirmValueSuccess}</Hint>:undefined}
      </>
    }
  </div>)
}

